import { reportRespondentError, type TRespondentErrorSurface } from '../api/respondent-errors';
import { parseApiError } from './api-error';

const reportedKeys = new Set<string>();

function dedupeKey(input: {
  formId?: string;
  surface: TRespondentErrorSurface;
  statusCode?: number;
  message: string;
}): string {
  return [input.formId ?? '', input.surface, input.statusCode ?? '', input.message].join('|');
}

/**
 * Fire-and-forget respondent error report. Dedupes identical errors per browser session.
 */
export function captureRespondentError(
  surface: TRespondentErrorSurface,
  error: unknown,
  context?: { formId?: string; linkId?: string },
): void {
  const parsed = parseApiError(error);
  const key = dedupeKey({
    formId: context?.formId,
    surface,
    statusCode: parsed.statusCode,
    message: parsed.message,
  });

  if (reportedKeys.has(key)) return;
  reportedKeys.add(key);

  reportRespondentError({
    formId: context?.formId,
    linkId: context?.linkId,
    surface,
    statusCode: parsed.statusCode,
    errorCode: parsed.errorCode,
    message: parsed.message,
    requestUrl: parsed.requestUrl,
  }).catch(() => {
    // Best-effort telemetry — never block the respondent UI.
  });
}

export function captureRespondentMessage(
  surface: TRespondentErrorSurface,
  message: string,
  context?: { formId?: string; linkId?: string; statusCode?: number },
): void {
  const key = dedupeKey({
    formId: context?.formId,
    surface,
    statusCode: context?.statusCode,
    message,
  });

  if (reportedKeys.has(key)) return;
  reportedKeys.add(key);

  reportRespondentError({
    formId: context?.formId,
    linkId: context?.linkId,
    surface,
    statusCode: context?.statusCode,
    message,
  }).catch(() => {});
}
